export const INSTALLATION_TIMES = {
  PDJ: {
    SMALL: { maxPeople: 80, time: 15 },
    MEDIUM: { maxPeople: 160, time: 30 },
    LARGE: { time: 30 }
  },
  PLATEAU_REPAS: { time: 10 },
  TRAITEUR_SANS_INSTALLATION: { time: 15 },
  TRAITEUR_AVEC_INSTALLATION: { time: 60 },
  INSTALLATION_VOITURE: { time: 8 }
};

export const TIME_FOR_RECOVERY = 15; // Temps pour une récupération

export const MOULIN_COORDS = {
  lat: 45.7613911, 
  lng: 4.9167728
};

export const LOADING_TIME = 10; // Temps de chargement au Moulin en minutes

// Temps de retour au dépôt avant la fin de la fenêtre (en minutes)
export const RETURN_TO_DEPOT_TIME = 15; // 15 minutes avant la fin de la fenêtre

// Fenêtres de travail des livreurs avec pauses
export const DRIVER_WORK_WINDOWS = {
  MORNING: { start: 6, end: 10.25}, // 6h00 - 10h15
  MID_MORNING: { start: 10, end: 13.25}, // 10h00 - 13h15 
  AFTERNOON: { start: 13, end: 23} // 13h00 - 23h00
};

export const MAX_PEOPLE_PER_VEHICLE = 300;